// ======================================================================
// File Name       : ContentDrillSkinAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import _ from 'lodash';
import * as actionTypes from '../../constants/ActionTypes';
import { commonCallApi } from '../../utils/ApiUtils';
import { hideLoading } from '../../utils/PageUtils';
import { CONTENT_DRILL_SKIN_LIST } from '../../constants/PathConstants';

export function searchSkin(searchInfo = {}) {
  return dispatch => commonCallApi({
    path: 'SkinList',
    data: searchInfo,
    drillServer: true,
  }).then((result) => {
    dispatch({
      type: actionTypes.CONTENT_DRILL_SKIN_SEARCH_RESULT,
      skinListResult: result,
    });
  });
}

export function skinEdit(param, history) {
  return (dispatch) => {
    commonCallApi({
      path: 'SkinUpdate',
      data: param,
      muiltipart: 1,
      drillServer: true,
    })
    .then((result) => {
      dispatch(hideLoading());
      dispatch({
        type: actionTypes.CONTENT_DRILL_SKIN_EDIT,
        skinSetSecernId: result.skinSetSecernId,
      });
      history.push(CONTENT_DRILL_SKIN_LIST);
    });
  };
}

export function skinInsert(param, history) {
  return (dispatch) => {
    commonCallApi({
      path: 'SkinInsert',
      data: param,
      muiltipart: 1,
      drillServer: true,
    })
    .then((result) => {
      dispatch(hideLoading());
      dispatch({
        type: actionTypes.CONTENT_DRILL_SKIN_INSERT,
        skinSetSecernId: result.skinSetSecernId,
      });
      history.push(CONTENT_DRILL_SKIN_LIST);
    });
  };
}

export function deleteSkin(skinSetInfo = {}, history) {
  return (dispatch) => {
    commonCallApi({
      path: 'SkinSetDelete',
      data: skinSetInfo,
      drillServer: true,
    })
    .then((result) => {
      history.push(CONTENT_DRILL_SKIN_LIST);
    });
  };
}

export function downloadSkinFile(skinSetInfo = {}) {
  return (dispatch) => {
    commonCallApi({
      path: 'SkinSetDownload',
      data: skinSetInfo,
      drillServer: true,
    })
    .then((result) => {
      dispatch(hideLoading());
      if (result.zipfileUrl) {
        const link = document.createElement('a');
        link.href = result.zipfileUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
}

// #7080 START
export function optionSkinInsert() {
  return () => commonCallApi({
    path: 'OptionSkinInsert',
    drillServer: true,
  });
}
// #7080 END
